//import functions from '../functions.js';

const calendar = {

    availabilityMask: null,
    minStay: null,
    translations: null,
    containerClass: null,
    today: null,
    yesterday: null,
    config: {},
    defaults: {
        availabilityMask: '',
        minStay: '',
        translations: {},
        containerClass: '',
        dateFormat: "Y-m-d",
        showMonths: 4,
        nextArrow: '<i class="fa-light fa-arrow-right"></i>',
        prevArrow: '<i class="fa-light fa-arrow-left"></i>',

        checkOutClass: 'checkOutAllowed',
        checkOutOnlyClass: 'checkOutOnlyAllowed',
        checkInClass: 'checkInAllowed',
        notAvailableClass: 'notAvailable',
        notArrivalDepartureClass: 'disabled',
        notMinStayClass: 'disabled',

        rangeSeparator: ' - ',

        defaultDate: [],
        minDate: 'today',
        inline: true,
        altInput: true,
        wrap: false,
        altFormat: "j.m.Y",
        prevStatus: null
    },

    init($elem, config, callback) {

        calendar.config = $.extend({}, calendar.defaults, config);
        calendar.config.minStay = calendar.config.minStay.split(',');

        calendar.today = new Date();
        calendar.today = new Date(calendar.today.getTime() + ((calendar.today.getTimezoneOffset() + 60) * 60000));

        calendar.today.setHours(0,0,0,0);

        calendar.yesterday = new Date(calendar.today.getTime());
        calendar.yesterday.setDate(calendar.yesterday.getDate() - 1);

        /*window.mobileAndTabletCheck = function () {
            let check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };*/

        /*
        xxs: 0,
        xs: 400px,
        sm: 576px,
        md: 768px,
        lg: 992px,
        xl: 1360px,
        xxl: 1600px
        */

        if(window.innerWidth > 992 && window.innerWidth <= 1360) {
            calendar.config.showMonths = 3;
        } else if(window.innerWidth > 576 && window.innerWidth <= 992) {
            calendar.config.showMonths = 2;
        } else if(window.innerWidth <= 576) {
            calendar.config.showMonths = 1;
        }

        let flatpickr = $elem.flatpickr({

            altInput: calendar.config.altInput,
            wrap: calendar.config.wrap,
            altFormat: calendar.config.altFormat,
            dateFormat: calendar.config.dateFormat,
            disableMobile: true,
            mode: calendar.config.mode,
            minRange: 0,
            showMonths: calendar.config.showMonths,
            inline: calendar.config.inline,
            defaultDate: calendar.config.defaultDate,
            minDate: calendar.config.minDate,
            onDayCreate: function (dObj, dStr, fp, dayElem) {

                let status = calendar.getStatus(dayElem.dateObj);

                if (! status || status == 'N')
                {
                    calendar.setDayNonAvailable(dayElem);
                    return;
                }
                else if (status == 'A')
                {

                }
                else if (status == 'S')
                {
                    calendar.setDayNotArrivalPossible(dayElem);
                }
                else if (status == 'D')
                {
                    calendar.setDayCheckOutOnlyAvailable(dayElem);
                }
                else if (status == 'I' || status == 'E')
                {
                    dayElem.className += ' ' + calendar.config.checkInClass;
                }
                else if (status == 'O')
                {
                    calendar.setDayCheckOutAvailable(dayElem);
                }

                let onlyCheckInSelected = fp.selectedDates[0] && ! fp.selectedDates[1];

                if (onlyCheckInSelected) {

                    // CHECK MIN STAY
                    let minStay = calendar.getMinStay(fp.selectedDates[0]);

                    if (minStay) {
                        // get difference between selected and current date of the loop
                        // check if min stay is met - skip selected date
                        let diff = calendar.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                        if (Math.abs(diff) < minStay) {
                            calendar.setDayNotMinStay(dayElem, diff, minStay);
                        }
                    }

                    fp.calendarContainer.classList.add('selection');

                    if (+dayElem.dateObj != +fp.selectedDates[0] && ! calendar.isAvailable(dayElem.dateObj, fp.selectedDates[0])) {
                        calendar.setDayNotAllowedRange(dayElem);
                        return;
                    }

                    if (dayElem.dateObj.getTime() < fp.selectedDates[0].getTime()) {
                        calendar.setDayNotAllowedRange(dayElem);
                    } else {
                        calendar.removeNotAllowedRange(dayElem);
                    }

                    if (status == 'E')
                    {
                        calendar.setDayNotAllowedRange(dayElem);
                    }

                } else {
                    fp.calendarContainer.classList.remove('selection');
                }

                calendar.config.prevStatus  = status;
            },
            onChange: function (selectedDates, dateStr, instance) {
                callback(calendar.getDateFrom(selectedDates), calendar.getDateTo(selectedDates));
            },
            onReady: function (selectedDates, dateStr, instance) {

                if (calendar.config.containerClass) {
                    let classList = instance.calendarContainer.classList;
                    let classes = calendar.config.containerClass.split(' ');
                    classes.forEach(function (css_class, index) {
                        classList.add(css_class);
                    });
                }
            },

            nextArrow: calendar.config.nextArrow,
            prevArrow: calendar.config.prevArrow,
            locale: {
                rangeSeparator: calendar.config.rangeSeparator
            }
        });

        return flatpickr;
    },
    getDateFrom: function (selectedDates) {
        if ( ! selectedDates[0]) return null;
        if ( ! selectedDates[1]) return selectedDates[0];

        return selectedDates[0] < selectedDates[1] ? selectedDates[0] : selectedDates[1];
    },
    getDateTo: function (selectedDates) {
        if ( ! selectedDates[1]) return null;

        return selectedDates[0] < selectedDates[1] ? selectedDates[1] : selectedDates[0];
    },
    isAvailable(from, to) {

        if ( ! to) {
            to = calendar.addDate(calendar.cleanDate(from), 1);
        }

        let dateFrom = from < to ? from : to;
        let dateTo = to > from ? to : from;

        if (dateFrom < calendar.yesterday) {
            return false;
        }

        if ( ! calendar.config.availabilityMask) return false;

        let diff = calendar.dateDiff(dateFrom, calendar.today);
        let dateToDiff = (diff + calendar.dateDiff(dateTo, dateFrom));
        let mask = '' + calendar.config.availabilityMask.substring(diff, dateToDiff);

        return mask ? mask.indexOf('N') === -1 : false;
    },
    getStatus(from, to) {

        if ( ! to) {
            to = calendar.addDate(calendar.cleanDate(from), 1);
        }

        let dateFrom = from < to ? from : to;
        let dateTo = to > from ? to : from;

        if (dateFrom <= calendar.yesterday) {
            return 'N';
        }

        if ( ! calendar.config.availabilityMask) return 'N';

        let diff = calendar.dateDiff(dateFrom, calendar.today);
        let dateToDiff = (diff + calendar.dateDiff(dateTo, dateFrom));
        let mask = '' + calendar.config.availabilityMask.substring(diff, dateToDiff);

        return mask;
    },
    addDate: function (date, days) {
        date = calendar.cleanDate(date);
        date.setDate(date.getDate() + days)
        return date;
    },
    formatDate(date) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        let d = new Date(date);
        return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('.')
    },
    dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());

        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    },
    setDayCheckOutAvailable(dayElem) {
        dayElem.className += ' ' + calendar.config.checkOutClass;
    },
    setDayCheckOutOnlyAvailable(dayElem) {
        dayElem.className += ' ' + calendar.config.checkOutOnlyClass;
    },
    setDayNonAvailable(dayElem) {

        dayElem.className += ' ' + calendar.config.notAvailableClass;

        $(dayElem).tooltip({
            title: calendar.config.translations.not_available || ''
        });
    },
    setDayNotArrivalPossible(dayElem) {
        dayElem.className += ' flatpickr-disabled ' + calendar.config.notArrivalDepartureClass;
        $(dayElem).tooltip({
            title: calendar.config.translations.not_arrival_day || ''
        });
    },
    setDayNotDeparturePossible(dayElem) {
        dayElem.className += ' flatpickr-disabled ' + calendar.config.notArrivalDepartureClass;
        $(dayElem).tooltip({
            title: calendar.config.translations.not_departure_day || ''
        });
    },
    setDayNotMinStay(dayElem, diff, minStay) {
        dayElem.className += ' flatpickr-disabled ' + calendar.config.notMinStayClass;
        if (diff) {
            $(dayElem).tooltip({
                title: calendar.config.translations.min_stay_is && calendar.config.translations.min_stay_is.replace('{$min_stay}', minStay) || ''
            });
        }
    },
    setDayNotAllowedRange(dayElem) {

        dayElem.className += ' notAllowedRange';

        $(dayElem).tooltip({
            title: ''
        });
    },
    removeNotAllowedRange(dayElem) {
        dayElem.className = dayElem.className.replace(' notAllowedRange', '');
    },
    getMinStay(date) {

        if ( ! calendar.config.minStay.length) return 0;

        let diff = calendar.dateDiff(date, calendar.today);

        return calendar.config.minStay[diff] || 0;

    },
    cleanDate(date) {
        date = new Date(date);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }
}
module.exports = {
    calendar: calendar
};